/**
 * Returns true if the current platform is Mac
 */
export const isMac = (): boolean => {
  if (typeof navigator === 'undefined') return false;
  // Use modern userAgentData API if available, fallback to deprecated navigator.platform
  const nav = navigator as Navigator & { userAgentData?: { platform?: string } };
  if (nav.userAgentData?.platform) {
    return nav.userAgentData.platform.toUpperCase().includes('MAC');
  }
  return navigator.platform.toUpperCase().includes('MAC');
};

/**
 * Returns the platform-appropriate modifier key label
 */
export const getModifierKeyLabel = (): string => {
  return isMac() ? 'Cmd' : 'Ctrl';
};

/**
 * Formats a keyboard shortcut for display
 */
export const formatShortcut = (
  key: string,
  options?: { cmdOrCtrl?: boolean; ctrl?: boolean; shift?: boolean }
): string => {
  const parts: string[] = [];
  if (options?.cmdOrCtrl) {
    parts.push(getModifierKeyLabel());
  } else if (options?.ctrl) {
    parts.push('Ctrl');
  }
  if (options?.shift) {
    parts.push('Shift');
  }
  parts.push(key.toUpperCase());
  return parts.join('+');
};
